import { FC } from 'react'
import { ToastContainer, ToastContainerProps } from 'react-toastify'
import styled from 'styled-components'
import { darken } from 'polished'
import { validFor } from '@/theme/validFor'
import { DesktopOrTablet, MediaContextProvider, Mobile } from '../atoms/media'

const ToastWrapper: FC<Rest> = ({ ...rest }) => {
  const props: ToastContainerProps = {
    autoClose: 10000,
    theme: 'dark',
    draggablePercent: 50
  }

  return (
    <div {...rest}>
      <MediaContextProvider>
        <DesktopOrTablet>
          <ToastContainer position="top-left" {...props} />
        </DesktopOrTablet>
        <Mobile>
          <ToastContainer position="top-center" {...props} />
        </Mobile>
      </MediaContextProvider>
    </div>
  )
}

const Toast = styled(ToastWrapper)`
  .Toastify__toast-container {
    ${validFor.wide`
      width: 500px;
    `}
    left: 20px;
    margin-right: 20px;
    font-size: 14px;
    ${validFor.mobile`
      left: 5%;
      margin-right: 0;
      margin-top: 60px;
      width: 90%;
    `}
  }
  .Toastify__toast-theme--dark {
    background: ${({ theme }) => theme.colors.onBackground};
    color: ${({ theme }) => theme.colors.background};
    ${validFor.mobile`
      margin-bottom: 6px;
    `}
  }
  .Toastify__toast--error {
    background: ${({ theme }) => darken(0.45, theme.colors.error)};
  }
  .Toastify__toast--success {
    background: ${({ theme }) => darken(0.3, theme.colors.success)};
  }
  .Toastify__toast--warning {
    background: ${({ theme }) => darken(0.4, theme.colors.warning)};
  }
  .Toastify__toast--info {
    background: ${({ theme }) => darken(0.45, theme.colors.info)};
  }
`

export default Toast
